module.exports = __webpack_public_path__ + "img/TF.faf7e492.png";